import { AccountStatus, CustomerAccount, CustomerPayment } from './types'

export const isAccountActive = (customerAccount: CustomerAccount): boolean =>
  customerAccount.accountStatus === AccountStatus.ACTIVE

export const getPaymentPremium = (payment: CustomerPayment | undefined) =>
  payment ? payment.amount / 100 : 0
